function DashTitle({ username }) {
  return (
    <div className="wholeTitle">
      <h1>Welcome {username}</h1>
    </div>
  );
}

export default DashTitle;
